import { render, staticRenderFns } from "./NewAffiliatesAccount.vue?vue&type=template&id=799de890&scoped=true&"
import script from "./NewAffiliatesAccount.vue?vue&type=script&lang=js&"
export * from "./NewAffiliatesAccount.vue?vue&type=script&lang=js&"
import style0 from "./NewAffiliatesAccount.vue?vue&type=style&index=0&id=799de890&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799de890",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('799de890')) {
      api.createRecord('799de890', component.options)
    } else {
      api.reload('799de890', component.options)
    }
    module.hot.accept("./NewAffiliatesAccount.vue?vue&type=template&id=799de890&scoped=true&", function () {
      api.rerender('799de890', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Affiliates/NewAffiliatesAccount.vue"
export default component.exports